<template>
    <div>
        <PageHeader :title="pageHeader" description="Todas as suas informações cadastrais"></PageHeader>
    </div>
</template>

<script>

export default {
    setup() {
        const pageHeader = 'Meu Perfil';

        return {
            pageHeader
        }
    },
}
</script>